import React, { Component } from 'react';

import ContestsCardItem from './ContestsCardItem';

export default class ContestsViewHome extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.generateContestItems = this.generateContestItems.bind(this);

        this.generateSection = this.generateSection.bind(this);
    }

    generateContestItems(contestList, category) {
        let contestJsxList = [];

        contestList.forEach((contest) => {
            let contestId = contest.rankedContestId != undefined ? contest.rankedContestId : contest.raffleContestId;
            contestJsxList.push((
                <ContestsCardItem
                    category={category}
                    identity={contest}
                    handleDelete={this.props.handleDelete}
                    handleArchive={this.props.handleArchive}
                    isActive={contestId === this.props.selectedContestId}
                    handleSelectContest={this.props.handleSelectContest}
                    handleModeChange={this.props.handleModeChange}
                    startEditContest={this.props.startEditContest}
                    startInfoContest={this.props.startInfoContest}
                    startResultsContest={this.props.startResultsContest}
                />
            ));
        });

        return contestJsxList;
    }

    generateSection(contestsObj, sectionLabel) {

        let result = {
            active: null,
            complete: null,
            archive: null
        };

        let activeClientAccountContests = this.generateContestItems(contestsObj.active.clientAccount, 'active');
        let activeLocationContests = this.generateContestItems(contestsObj.active.location, 'active');
        let activeGroupContests = this.generateContestItems(contestsObj.active.group, 'active');

        let completeClientAccountContests = this.generateContestItems(contestsObj.complete.clientAccount, 'complete');
        let completeLocationContests = this.generateContestItems(contestsObj.complete.location, 'complete');
        let completeGroupContests = this.generateContestItems(contestsObj.complete.group, 'complete');

        let archiveContests = this.generateContestItems(contestsObj.archive, 'archive');

        if (activeClientAccountContests.length === 0 && activeLocationContests.length === 0 && activeGroupContests.length === 0 &&
            completeClientAccountContests.length === 0 && completeLocationContests.length === 0 && completeGroupContests.length === 0 &&
            archiveContests.length === 0) {
            return result;
        }

        if (activeClientAccountContests.length > 0 || activeLocationContests.length > 0 || activeGroupContests.length > 0) {
            let activeSec = [];

            if (activeClientAccountContests.length > 0) {
                activeSec.push((<div className="settings-central-regular-card-label">{"Company Wide"}</div>));
                activeSec.push(activeClientAccountContests);
            }
            if (activeLocationContests.length > 0) {
                activeSec.push((<div className="settings-central-regular-card-label">{"Location"}</div>));
                activeSec.push(activeLocationContests);
            }
            if (activeGroupContests.length > 0) {
                activeSec.push((<div className="settings-central-regular-card-label">{"Group"}</div>));
                activeSec.push(activeGroupContests);
            }

            result.active = [(<div className="gc-major-label">{"Active - " + sectionLabel}</div>), (<div className="settings-central-regular-card-container">{activeSec}</div>)]
        }

        if (completeClientAccountContests.length > 0 || completeLocationContests.length > 0 || completeGroupContests.length > 0) {
            let completeSec = [];

            if (completeClientAccountContests.length > 0) {
                completeSec.push((<div className="settings-central-regular-card-label">{"Company Wide"}</div>));
                completeSec.push(completeClientAccountContests);
            }
            if (completeLocationContests.length > 0) {
                completeSec.push((<div className="settings-central-regular-card-label">{"Location"}</div>));
                completeSec.push(completeLocationContests);
            }
            if (completeGroupContests.length > 0) {
                completeSec.push((<div className="settings-central-regular-card-label">{"Group"}</div>));
                completeSec.push(completeGroupContests);
            }

            result.complete = [(<div className="gc-major-label">{"Complete - " + sectionLabel}</div>), (<div className="settings-central-regular-card-container">{completeSec}</div>)]
        }

        if (archiveContests.length > 0) {
            let archiveSec = [];

            // archiveSec.push((<div className="settings-central-regular-card-label">{""}</div>));
            archiveSec.push(archiveContests);

            result.archive = [(<div className="gc-major-label">{"Archive - " + sectionLabel}</div>), (<div className="settings-central-regular-card-container">{archiveSec}</div>)]
        }

        return result;
    }

    render() {
        let contestsObj = this.props.contestsObj;

        let raffleSet = this.generateSection(contestsObj.raffle, "Raffle");
        let rankedSet = this.generateSection(contestsObj.ranked, "Ranked");

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className="material-icons gc-add-button" onClick={this.props.startNewContest.bind(null, "emp")}>{"add person"}</div>
                <div className="material-icons gc-add-button" onClick={this.props.startNewContest.bind(null, "loc")}>{"add store_mall_directory"}</div>
                {raffleSet.active}
                {rankedSet.active}
                {raffleSet.complete}
                {rankedSet.complete}
                {raffleSet.archive}
                {rankedSet.archive}
                <div className="spacer-2"></div>
            </div>
        );
    }
}